/**
 * The page's flags a replay link carries (decision 81): the player's language, the operator's branding, the device
 * shape, and the dev flags with the backend they name. The link is opened in a new tab and may be shared, so anything
 * else stays behind: the casino's launch above all, which would let whoever holds the link play as this player, the
 * free-play currency, and any parameter a later link adds.
 */
const REPLAY_LINK_FLAGS = ["lang", "operator", "device", "dev", "backend"] as const;

/** This page's address, its flags kept by name, with `replay` set to the round. */
export function replayLink(pageUrl: string, roundId: string): string {
  const page = new URL(pageUrl);
  const link = new URL(page.origin + page.pathname);
  for (const flag of REPLAY_LINK_FLAGS) {
    const value = page.searchParams.get(flag);
    if (value !== null) link.searchParams.set(flag, value);
  }
  link.searchParams.set("replay", roundId);
  return link.toString();
}
